import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ui';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import moment from 'utils/cops-moment';

const Title = styled.span`
  font-size: 16px;
  margin-left: 10px;
  color: rgba(100,116,124,0.85);
`;

const Wrapper = styled.div`
  padding: 15px;
  width: 100%;
  border-bottom: 1px solid rgba(100,116,124,0.3);
`;

const BoldText = styled.span`
  font-weight: 600;
`;

const Description = styled.div`
  font-size: 16px;
`;

const DateAndTime = styled.p`
  &:first-letter {
    text-transform: uppercase;
  }
  font-size: 12px;
  color: rgba(100,116,124,0.85);
  margin-left: 32px;
`;

const RescheduleItem = ({
  changedBy,
  changedOn,
  description,
  icon,
  title,
  intl,
}) =>
  <Wrapper>
    <Icon type={icon} size='2x' light={true} />
    <Title>
      <span>
        <BoldText>{title}</BoldText>{' '}
        {intl.formatMessage({ id: 'planningBoard.blocks.BY' })?.toLowerCase()}{' '}
        {changedBy}
      </span>
    </Title>
    <DateAndTime>
      {changedOn ?
        `${moment(changedOn).fromNow()} (${moment(changedOn).format('ll [-] LT')})` :
        null
      }
    </DateAndTime>
    <Description>
      {description}
    </Description>
  </Wrapper>;
RescheduleItem.propTypes = {
  changedBy: PropTypes.string,
  changedOn: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(RescheduleItem);
